export default __webpack_public_path__ + "static/media/Titan.17c5408d.png";